export default "Home Page placeholder\n";